import Button from '@global/Button'
import GridItems from '@global/GridItems'
import IconMinus from '@icons/Minus'
import IconPlus from '@icons/Plus'
import ReaLogo from '@icons/ReaLogo'
import { getREATestimonials } from '@lib/api-services/reaTestimonialsService'
import { useEffect, useState } from 'react'
import Testimonial from '../SitewideTestimonials/Testimonial'
import { SubTitle, ToggleButtonWrapper } from './ReaRatedTestimonials.styled'

const ReaRatedTestimonials = ({
  title,
  testimonials,
  initialPage = 0,
  perPage = 9,
  officeId,
  agentId,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(initialPage)
  const [allTestimonials, setAllTestimonials] = useState([])
  const [fullTestimonialSet, setFullTestimonialSet] = useState([])
  const [totalTestimonials, setTotalTestimonials] = useState(0)

  const formatTestimonials = (data) => {
    return data.map((t) => ({
      ...t,
      rating: t.star_rating,
      copy: t.content,
    }))
  }

  useEffect(() => {
    if (testimonials?.length > 0) {
      const formattedTestimonials = formatTestimonials(testimonials)
      setAllTestimonials(formattedTestimonials)
      setFullTestimonialSet(formattedTestimonials)
    }
  }, [testimonials])

  const handleToggle = async () => {
    if (fullTestimonialSet.length > allTestimonials.length) {
      setAllTestimonials(() => [...fullTestimonialSet])
    }

    if (fullTestimonialSet.length === totalTestimonials) {
      return
    }

    setIsLoading(true)
    try {
      const nextPage = currentPage + 1
      const params = {
        page: nextPage,
        per_page: perPage,
      }

      if (officeId) {
        params.office = officeId
      }
      if (agentId) {
        params.agent = agentId
      }

      const response = await getREATestimonials(params)

      if (response?.results) {
        const newTestimonials = formatTestimonials(response.results)

        if (params.page === 1) {
          setAllTestimonials(newTestimonials)
          setFullTestimonialSet(newTestimonials)
        } else {
          setAllTestimonials((prev) => [...prev, ...newTestimonials])
          setFullTestimonialSet((prev) => [...prev, ...newTestimonials])
        }

        setTotalTestimonials(response.count)
        setCurrentPage(nextPage)
      }
    } catch (error) {
      console.error('Error loading more testimonials:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleViewLess = () => {
    const visibleItems = fullTestimonialSet.slice(0, 3)
    setAllTestimonials(visibleItems)

    window.scrollTo({
      top:
        document.getElementById(`grid-items-${officeId || agentId}`).offsetTop -
        (window.innerWidth > 767 ? 80 : 0),
      behavior: 'smooth',
    })
  }

  return (
    <GridItems
      id={`grid-items-${officeId || agentId}`}
      title={title}
      items={allTestimonials}
      itemSize={4}
      subTitle={
        <SubTitle>
          Reviews powered by <ReaLogo width={180} height={25} />
        </SubTitle>
      }
      minVisibleDesktopItems={allTestimonials.length}
      minVisibleMobileItems={allTestimonials.length}
      itemMarginBottom={48}
      renderItem={(testimonial) => <Testimonial testimonial={testimonial} />}
      style={{ padding: '80px 0' }}
      toggleButton={
        <ToggleButtonWrapper
          className={`toggle-button-wrapper ${
            allTestimonials.length > 3 ? 'hide-on-top' : 'hide-on-bottom'
          }`}
        >
          {allTestimonials.length > 3 && (
            <Button
              color='secondary'
              border
              disabled={isLoading}
              onClick={handleViewLess}
              endIcon={<IconMinus />}
            >
              View Less
            </Button>
          )}
          {(totalTestimonials === 0 ||
            allTestimonials.length < totalTestimonials) && (
            <Button
              color='secondary'
              border
              disabled={isLoading}
              onClick={handleToggle}
              endIcon={<IconPlus />}
            >
              {isLoading ? 'Loading...' : 'View More'}
            </Button>
          )}
        </ToggleButtonWrapper>
      }
    />
  )
}

ReaRatedTestimonials.defaultProps = {
  title: 'Testimonials',
  testimonials: [],
}

export default ReaRatedTestimonials
